import { useEffect, useRef } from "react";
import styled from "styled-components";

export default function ReviewCardPreview() {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const canvas = document.createElement("canvas");
    canvas.width = 32;
    canvas.height = 18;
    const context = canvas.getContext("2d");
    if (!context || !canvas.captureStream) return;
    context.fillStyle = "#000";
    context.fillRect(0, 0, canvas.width, canvas.height);
    const stream = canvas.captureStream(1);
    const video = videoRef.current;
    if (video) {
      video.srcObject = stream;
      void video.play().catch(() => undefined);
    }
    return () => {
      stream.getTracks().forEach(track => track.stop());
      if (video) video.srcObject = null;
    };
  }, []);

  return <Preview aria-hidden="true"><video ref={videoRef} autoPlay muted playsInline /></Preview>;
}

const Preview = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: #000;
  video { display: block; width: 100%; height: 100%; object-fit: cover; }
`;
